import React, { useState, useEffect } from 'react';
import { Button, message, Card, Tabs } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import supplyChainService, { ShipmentBatch, InboundShipment } from '../../services/supplyChainService';
import { LogisticsBatchTable } from './components/LogisticsBatchTable';
import { LogisticsShipmentTable } from './components/LogisticsShipmentTable';

const Logistics: React.FC = () => {
    const navigate = useNavigate();
    const [batches, setBatches] = useState<ShipmentBatch[]>([]);
    const [shipments, setShipments] = useState<InboundShipment[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        setLoading(true);
        try {
            const [bRes, sRes] = await Promise.all([
                supplyChainService.getShipmentBatches(),
                supplyChainService.getInboundShipments()
            ]);
            setBatches(Array.isArray(bRes.data) ? bRes.data : []);
            setShipments(Array.isArray(sRes.data) ? sRes.data : []);
        } catch (error) {
            message.error('Failed to load logistics data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleCreateBatch = () => {
        navigate('/supply-chain/logistics/batches/new');
    };

    return (
        <Card title="Logistics Center">
            <Tabs defaultActiveKey="1" items={[
                {
                    key: '1', label: 'Shipment Batches (Level 1)',
                    children: (
                        <div>
                            <Button type="primary" icon={<PlusOutlined />} onClick={handleCreateBatch} style={{ marginBottom: 16 }}>Create Batch</Button>
                            <LogisticsBatchTable dataSource={batches} loading={loading} />
                        </div>
                    )
                },
                {
                    key: '2', label: 'FBA Shipments (Level 2)',
                    children: <LogisticsShipmentTable dataSource={shipments} loading={loading} />
                }
            ]} />
        </Card>
    );
};

export default Logistics;
